import React from "react";
import styles from "./wedding-date.module.css";
import { useLanguage } from "../../utils/language";

function WeddingDate() {
  const { getTranslation } = useLanguage();

  return (
    <div className={styles.bottomContent}>
      <div>
        <p
          className={styles.landingTitle}
          dangerouslySetInnerHTML={{
            __html: getTranslation("landing_title_invite"),
          }}
        />
      </div>

      <div className={styles.dateContainer}>
        <div className={styles.date}>
          <div className={styles.divider} />
          <p className={styles.dateText}>
            {getTranslation("wedding_date_days")}
          </p>
          <div className={styles.divider} />
        </div>

        <div className={styles.date}>
          <p className={styles.landingTitle}>
            {getTranslation("wedding_date_month")}
          </p>
          <p className={styles.dateDay}>25</p>
          <p className={styles.landingTitle}>2025</p>
        </div>

        <div className={styles.date}>
          <div className={styles.divider} />
          <p
            className={styles.dateText}
            dangerouslySetInnerHTML={{
              __html: getTranslation("wedding_date_time"),
            }}
          ></p>
          <div className={styles.divider} />
        </div>
      </div>
    </div>
  );
}

export default WeddingDate;
